const scrollButtons = {

    init () {

        let scrollButton = document.querySelector('.scrollto-button');

if(scrollButton){
    
    scrollButton.addEventListener('click', e => {
        window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: "smooth" });

    })
   // Set up the throttler 
    const throttle = (fn, delay) => { 
    // Capture the current time 
    let time = Date.now(); 
   
   
    // Here's our logic 
    return () => { 
      if((time + delay - Date.now()) <= 0) { 
        // Run the function we've passed to our throttler, 
        // and reset the `time` variable (so we can check again). 
        fn(); 
        time = Date.now(); 
      } 
    } 
  } 
   
  function runOnScroll(){ 

    if (window.scrollY > window.innerHeight / 2){
        scrollButton.addEventListener('click', e => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        })

        scrollButton.innerHTML = 'Retour en haut';
        scrollButton.classList.remove('tobottom');
        scrollButton.classList.add('totop');
    }

    if (window.scrollY < window.innerHeight / 2){
        scrollButton.addEventListener('click', e => {
            window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: "smooth" });

        })

        scrollButton.innerHTML = 'Scroll';
        scrollButton.classList.remove('totop');
        scrollButton.classList.add('tobottom');
    }
  } 
   
  window.addEventListener('scroll', throttle(runOnScroll, 200)); 

};

let scrollButtonResp = document.querySelector('.scrollto-button-resp');

if(scrollButtonResp){
    scrollButtonResp.addEventListener('click', e => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
});
}
    }
}

export default scrollButtons;